import { render } from "./SMain.vue?vue&type=template&id=5b678706"
import script from "./SMain.vue?vue&type=script&lang=js"
export * from "./SMain.vue?vue&type=script&lang=js"

import "./SMain.vue?vue&type=style&index=0&id=5b678706&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__